<template>
  <div class="carousel-container">
    <div class="carousel-wrapper fade-in">
      <div class="carousel-slide" :key="current">
        
        <!-- 슬라이드 이미지 영역 -->
        <div class="carousel-media">
          <component :is="slides[current].component" />
        </div>

        <!-- 텍스트 -->
        <div class="carousel-text">
          <h4 class="accent">{{ slides[current].title }}</h4>
          <p>{{ slides[current].description }}</p>
        </div>

      </div>
    </div>

    <div class="carousel-indicators">
      <span
        v-for="(item, index) in slides"
        :key="index"
        class="dot"
        :class="{ active: current === index }"
        @click="current = index"
      ></span>
    </div>
  </div>
</template>


<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

import Slide1AnimatedImages from './Slide1AnimatedImages.vue';
import Slide2Graph from './Slide2Graph.vue';

const { t } = useI18n();

const slides = computed(() => [
  {
    component: Slide1AnimatedImages,
    title: t('ss_login_carousel_slide_1_1'),
    description: t('ss_login_carousel_slide_1_2'),
  },
  {
    component: Slide2Graph,
    title: t('ss_login_carousel_slide_2_1'),
    description: t('ss_login_carousel_slide_2_2'),
  },
]);

const current = ref(0);
let intervalId: number | null = null;

onMounted(() => {
  intervalId = setInterval(() => {
    current.value = (current.value + 1) % slides.value.length;
  }, 15000);
});

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
</script>

<style scoped lang="scss">
.carousel-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
}

.carousel-slide {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.carousel-media {
  display: flex;
  height: 23rem;
  width: 100%;
  padding: 1rem;
  border-radius: 16px;
  justify-content: center;
  align-items: center;
  background-color: var(--surface-default);
}

.carousel-image {
  border-radius: 16px;
  background-color: var(--surface-default);
  height: 23rem;
  width: 100%;
}

.carousel-text {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.carousel-indicators {
  display: flex;
  gap: 0.25rem;
  justify-content: center;
}

.dot {
  width: 0.6rem;
  height: 0.6rem;
  background-color: var(--surface-primary-dim);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.dot.active {
  background-color: var(--surface-primary);
}
</style>
